<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="礼品" prop="giftId">
            <Select v-model="formValidate.giftId" placeholder="选择礼品" @on-change="giftChange">
              <Option v-for="g in giftList" :key="g.id" :value="g.id">{{ g.name }}（积分{{ g.integralBranch }}，可兑换{{ g.saleQuantity }}）</Option>
            </Select>
          </FormItem>
          <FormItem label="礼品名称"><Input class="widK" disabled v-model="formValidate.giftName" /></FormItem>
          <FormItem label="积分单价"><Input class="widK" disabled v-model="formValidate.integralBranch" /></FormItem>
          <FormItem label="兑换人" prop="name">
            <Row>
              <Col span="20"><Input class="widK" disabled :value="formValidate.name ? formValidate.name + '（' + formValidate.idCard + '）' : ''" placeholder="请选择兑换人" /></Col>
              <Col span="3" style="margin-left:8px"><Button type="primary" @click="personModal = true">选择</Button></Col>
            </Row>
          </FormItem>
          <FormItem label="兑换数量" prop="exchangeCount"><Input class="widK" v-model.trim="formValidate.exchangeCount" placeholder="数量" @on-change="calcTotal" /></FormItem>
          <FormItem label="消耗积分"><Input class="widK" disabled v-model="formValidate.totalBranch" /></FormItem>
          <FormItem label="兑换时间" prop="exchangeTime">
            <DatePicker class="widK" type="datetime" v-model="formValidate.exchangeTime" placeholder="选择时间" format="yyyy-MM-dd HH:mm:ss"></DatePicker>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="primary" @click="submit">确定</Button>
        <Button type="default" style="margin:0 16px" @click="handleReset">重置</Button>
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>

    <Modal v-model="personModal" title="选择兑换人" width="700">
      <Row :gutter="8" style="margin-bottom:10px">
        <Col span="8"><Input v-model="personSearchName" type="text" placeholder="姓名" clearable @on-clear="searchPerson" /></Col>
        <Col span="8"><Input v-model="personSearchIdCard" type="text" placeholder="身份证号码" clearable @on-clear="searchPerson" /></Col>
        <Col span="4"><Button type="primary" icon="ios-search" @click="searchPerson">查询</Button></Col>
      </Row>
      <Table border size="small" :columns="personColumns" :data="personTableData" :height="400" @on-current-change="selectPerson" highlight-row></Table>
      <div slot="footer">
        <Button type="primary" :disabled="!selectedPerson" @click="confirmPerson">确定</Button>
        <Button type="default" @click="personModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "giftExchangeAdd",
  data() {
    return {
      giftList: [], personList: [], personTableData: [], selectedPerson: null,
      personModal: false,
      personSearchName: "", personSearchIdCard: "",
      formValidate: { giftId: "", giftName: "", integralBranch: 0, name: "", idCard: "", exchangeCount: "", totalBranch: 0, exchangeTime: "" },
      ruleValidate: {
        giftId: [{ required: true, message: "请选择礼品", trigger: "change" }],
        name: [{ required: true, message: "请选择兑换人", trigger: "change" }],
        exchangeCount: [{ required: true, message: "请填写数量", trigger: "blur" }],
        exchangeTime: [{ required: true, type: "date", message: "请选择时间", trigger: "change" }],
      },
      personColumns: [
        { type: "index", title: "序号", width: 80, align: "center" },
        { title: "姓名", key: "name", minWidth: 100, align: "center" },
        { title: "身份证号码", key: "idCard", minWidth: 200, align: "center" },
        { title: "获取总积分", key: "totalBranch", minWidth: 100, align: "center" },
        { title: "剩余积分", key: "remainBranch", minWidth: 100, align: "center",
          render: (h, p) => h("span", p.row.remainBranch != null ? p.row.remainBranch : p.row.totalBranch) },
      ],
    };
  },
  created() { this.loadGifts(); this.loadPersons(); },
  methods: {
    loadGifts() { this.$http.get("/api/tGiftItem/page", { params: { pageSize: 999 } }).then(r => { if (r.data.code == 200) this.giftList = r.data.data.list || []; }); },
    loadPersons() { this.$http.get("/api/tIntegralPeopleItem/statistics", { params: { pageSize: 999 } }).then(r => { if (r.data.code == 200) { this.personList = r.data.data || []; this.personTableData = r.data.data || []; } }); },
    searchPerson() {
      let list = this.personList;
      if (this.personSearchName) list = list.filter(x => x.name && x.name.includes(this.personSearchName));
      if (this.personSearchIdCard) list = list.filter(x => x.idCard && x.idCard.includes(this.personSearchIdCard));
      this.personTableData = list;
    },
    selectPerson(currentRow) { this.selectedPerson = currentRow; },
    confirmPerson() {
      if (!this.selectedPerson) return;
      this.formValidate.name = this.selectedPerson.name;
      this.formValidate.idCard = this.selectedPerson.idCard;
      // 计算最大可兑换数量（基于剩余积分）
      let remainBranch = this.selectedPerson.remainBranch != null ? this.selectedPerson.remainBranch : this.selectedPerson.totalBranch;
      let price = parseInt(this.formValidate.integralBranch) || 0;
      if (price > 0) {
        var maxCount = Math.floor(remainBranch / price);
        if (maxCount < (parseInt(this.formValidate.exchangeCount) || 0)) {
          this.formValidate.exchangeCount = maxCount > 0 ? String(maxCount) : "0";
        }
      }
      this.personModal = false;
      this.calcTotal();
    },
    giftChange(val) { let g = this.giftList.find(x => x.id == val); if (g) { this.formValidate.giftName = g.name; this.formValidate.integralBranch = g.integralBranch; } this.calcTotal(); },
    calcTotal() { let c = parseInt(this.formValidate.exchangeCount) || 0; let p = parseInt(this.formValidate.integralBranch) || 0; this.formValidate.totalBranch = c * p; },
    submit() {
      this.$refs.formValidate.validate(v => {
        if (!v) return;
        let p = JSON.parse(JSON.stringify(this.formValidate));
        p.exchangeCount = parseInt(p.exchangeCount) || 0;
        p.integralBranch = parseInt(p.integralBranch) || 0;
        p.totalBranch = parseInt(p.totalBranch) || 0;
        if (p.exchangeTime) {
          var d = new Date(p.exchangeTime);
          var year = d.getFullYear();
          var month = (d.getMonth() + 1 + '').padStart(2, '0');
          var day = (d.getDate() + '').padStart(2, '0');
          var hour = (d.getHours() + '').padStart(2, '0');
          var minute = (d.getMinutes() + '').padStart(2, '0');
          var second = (d.getSeconds() + '').padStart(2, '0');
          p.exchangeTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        }
        this.$http.post("/api/tGiftExchange/save", p).then(r => { if (r.data.code == 200) { this.$Message.success("提交成功"); this.back(); } else { this.$Message.error(r.data.msg || "提交失败"); } }).catch(e => { this.$Message.error((e.response && e.response.data && e.response.data.msg) || "提交失败"); });
      });
    },
    handleReset() { this.$refs.formValidate.resetFields(); this.selectedPerson = null; },
    back() { this.$store.commit("app/closePage", { vm: this, fromName: this.$route.name, toName: "giftExchange" }); },
  },
};
</script>
<style scoped>
#content { width: 100%; }
.ivu-table td { white-space: nowrap; }
</style>
